import { Paper, Link, Typography, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import "react/jsx-runtime";
import "lottie-react";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "react";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../components/dialog/dialog.js";
import "../../../../../components/icons/all/all.js";
import { MessageBubbleIcon } from "../../../../../components/icons/MessageBubble/MessageBubble.js";
import { PhoneIcon } from "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/label/label.styles.js";
import "../../../../../components/menu-item/menu-item.js";
import "../../../../../components/slider/slider.styles.js";
import "../../../../../components/snackbar/snackbar.styles.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/translations/utils.js";
import "../../../../../components/time-select/time-select.styles.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import { InsuranceType } from "../../open-appointments-list.types.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Box/index.js";
const Wrapper = styled(Paper)(({ color }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "156px",
  backgroundColor: "#ffffff",
  width: "100%",
  borderRadius: "8px",
  padding: "8px",
  marginBottom: "12px",
  flexShrink: 0,
  overflow: "hidden",
  boxSizing: "border-box",
  boxShadow: "none",
  cursor: "pointer",
  "&:hover": {
    boxShadow: "0px 0px 8px rgba(33, 33, 33, 0.08), 0px 1px 1px rgba(33, 33, 33, 0.06)"
  },
  "&:after": {
    content: '""',
    position: "absolute",
    display: "block",
    height: "100%",
    top: 0,
    left: "4px",
    width: "6px",
    backgroundColor: "#ffffff",
    borderTopLeftRadius: "10px",
    borderBottomLeftRadius: "10px",
    zIndex: 2
  },
  "&:before": {
    content: '""',
    position: "absolute",
    display: "block",
    height: "100%",
    top: 0,
    left: 0,
    width: "8px",
    backgroundColor: color ?? "#ffffff",
    borderRadius: "8px",
    zIndex: 1
  }
}));
const PatientLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary[800],
  textDecoration: "none",
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline"
  }
}));
const Row = styled("div")`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding-left: ${({ paddingLeft }) => paddingLeft ? "12px" : 0};
  box-sizing: border-box;

  &:first-child {
    margin-bottom: ${({ theme }) => theme.spacing(1)};
  }
`;
const PatientName = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800],
  textTransform: "none"
}));
const TreatmentName = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[700]
}));
const Note = styled(Typography)(({ theme }) => ({
  overflow: "hidden",
  height: "32px",
  textOverflow: "ellipsis",
  color: theme.palette.grey[800],
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical"
}));
const ButtonGroup = styled("div")(({ theme }) => ({
  display: "flex",
  "& > button": {
    color: theme.palette.primary[800]
    // aqua mapped to primary
  }
}));
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  "&:hover": {
    backgroundColor: theme.palette.primary[50]
    // aqua mapped to primary
  },
  "&:first-child": {
    marginLeft: theme.spacing(-1)
  }
}));
const StyledPhoneIcon = styled(PhoneIcon)(({ theme }) => ({
  width: "20px",
  height: "20px",
  color: theme.palette.primary[800]
  // aqua mapped to primary
}));
const StyledMessageBubbleIcon = styled(MessageBubbleIcon)(({ theme }) => ({
  width: "20px",
  height: "20px",
  color: theme.palette.primary[800]
  // aqua mapped to primary
}));
const StyledExternalId = styled(Typography)(({ theme, type }) => ({
  color: theme.palette.grey[900],
  backgroundColor: theme.palette.grey[200],
  lineHeight: "16px",
  padding: "4px",
  borderRadius: "8px",
  textOverflow: "ellipsis",
  textAlign: "center",
  overflow: "hidden",
  ...type === InsuranceType.ADDITIONAL_PRIVATE_INSURANCE && {
    color: theme.palette.highlight3[900],
    backgroundColor: theme.palette.highlight3[50]
  },
  ...type === InsuranceType.PRIVATE_INSURANCE && {
    color: theme.palette.highlight1[900],
    backgroundColor: theme.palette.highlight1[50]
  },
  ...type === InsuranceType.SOCIAL_INSURANCE && {
    color: theme.palette.secondary[900],
    // orange mapped to secondary
    backgroundColor: theme.palette.secondary[50]
  }
}));
export {
  ButtonGroup,
  Note,
  PatientLink,
  PatientName,
  Row,
  StyledExternalId,
  StyledIconButton,
  StyledMessageBubbleIcon,
  StyledPhoneIcon,
  TreatmentName,
  Wrapper
};
